export const videos = [
  {
    youtubeId: "AkBTQhUKgao",
    title: "Tully’s freestyle training session. Focus on backwards weaving.",
    description:
      "Tully practices backwards weaves and focus work in a real environment. Simple patterns, short reps, high reward rate. Filmed in Boston, MA.",
    type: "training",
    slug: "tully-freestyle-backwards-weave",
    uploadDate: "2025-09-01",
    duration: "PT1M16S" 
  },
  {
    youtubeId: "wJ6vECs0Cu4",
    title: "Tully’s freestyle practice under the Rowes Wharf Arch.",
    description:
      "Freestyle session under the Rowes Wharf Arch with distractions. Handling, arousal control, and chaining tricks. Boston, MA.",
    type: "training",
    slug: "tully-freestyle-rowes-wharf-arch",
    uploadDate: "2025-09-01",
    duration: "PT0M41S"
  },
  {
    youtubeId: "LsJ_rdnYVlY",
    title: "How the Gear Works: Hands-Free Leash (3 Colors)",
    description:
      "Hands-free leash demo: how to wear it, adjust lengths, and switch setups for walking or training. Cambridge, MA.",
    type: "gear",
    slug: "hands-free-leash-demo",
    uploadDate: "2025-09-01",
    duration: "PT0M52S"
  },
  {
    youtubeId: "Y4E4o7WYllQ",
    title: "How to Use the Hands-Free Leash System",
    description:
      "A full demo showing how to wear, adjust, and use the hands-free leash system for walking, training, and switching between different leash setups.",
    type: "gear",
    slug: "how-to-use-hands-free-leash-system",
    uploadDate: "2026-06-15",
    duration: "PT6M38S"
  },
  {
    youtubeId: "lmv88apu7RM",
    title: "How the Gear Works: Ball Holder",
    description:
      "Ball holder attachment demo. Where it clips, how it carries the ball securely, and quick access during training.",
    type: "gear",
    slug: "ball-holder-demo",
    uploadDate: "2025-09-01",
    duration: "PT0M52S"
  },
  {
    youtubeId: "5zaoEDiXv_E",
    title: "Tully’s freestyle training session.",
    description:
      "Freestyle highlights with spins, weaves, and transitions. Short, fun reps keep focus and energy high.",
    type: "training",
    slug: "tully-freestyle-session-highlights",
    uploadDate: "2025-09-01",
    duration: "PT2M35S"
  }
];